import React, {Component, Fragment} from 'react';
import PropTypes          from 'prop-types';
import {Link}             from 'react-router-dom';
import {withRouter}       from 'react-router';
import classnames         from 'classnames';
import {
  Dimmer,
  Icon, Image,
} from 'semantic-ui-react';

// Style
import                    './MenuMobile.scss';

// Global
import menuList           from '../../global/menuList';
import getMessage         from '../../global/getMessage';

const propTypes = {
  lang           : PropTypes.shape({menu: PropTypes.object}),
  locale         : PropTypes.string,
  location       : PropTypes.shape({pathname: PropTypes.string}).isRequired,
  onChangeLangue : PropTypes.func.isRequired,
};
const defaultProps = {
  lang   : {},
  locale : 'en',
};

class MenuMobile extends Component {

  constructor(props) {
    super(props);

    this.state= {active: false};
    this.handleSetActive = this.handleSetActive.bind(this);
  }

  handleSetActive() {
    this.setState({active: !this.state.active});
  }

  render() {
    const {
      lang,
      locale,
      location: {pathname},
      onChangeLangue,
    } = this.props;

    locale;
    onChangeLangue;

    const listMenu = menuList(pathname).map((nm) => {
      const content = (
        <Fragment>
          <span className='menu-title'>
            {getMessage(nm.title, lang)[0]}
          </span>
          {
            nm.img
              ? (
                <Image
                  className='Menu-mobile-img'
                  src={`images/${nm.img}`}
                />
              )
              : (
                <Icon
                  name={nm.icon}
                  size='large'
                />
              )
          }
        </Fragment>
      );

      if (nm.to.includes('http')) {
        return (
          <a
            className={classnames(
              'menu-mobile-list',
              {loaded: this.state.active},
              {notransition: !this.state.active}
            )}
            href={nm.to}
            key={nm.key}
          >
            {content}
          </a>
        );
      }

      return (
        <Link
          className={classnames(
            'menu-mobile-list',
            {loaded: this.state.active},
            {notransition: !this.state.active}
          )}
          key={nm.key}
          onClick={this.handleSetActive}
          to={nm.to}
        >
          {content}
        </Link>
      );
    });

    // Add Localization Menu
    // Todo: set it back once all translations are done
    // listMenu.push(
    //   <div
    //     className={classnames(
    //       'menu-mobile-list',
    //       'menu-langue-mobile',
    //       {loaded: this.state.active},
    //       {notransition: !this.state.active}
    //     )}
    //     key='lang'
    //     onClick={onChangeLangue}
    //   >
    //     <span
    //       className={classnames(
    //         'lang-en',
    //         {active: locale === 'en'}
    //       )}
    //     >
    //       {'EN'}
    //     </span>
    //     {' / '}
    //     <span
    //       className={classnames(
    //         'lang-fr',
    //         {active: locale === 'fr'}
    //       )}
    //     >
    //       {'FR'}
    //     </span>
    //   </div>
    // );

    return (
      <React.Fragment>
        <Dimmer
          active={this.state.active}
          className='menu-dimmer'
          page
        />

        <div className='item right mobile'>
          <div
            className={classnames(

              'container-menu-mobile',
              {active: this.state.active}
            )}
            onClick={this.handleSetActive}
          >
            <div className='bar bar1' />
            <div className='bar bar2' />
            <div className='bar bar3' />
          </div>
        </div>

        <div className='sub-menu-mobile'>
          <div
            className={classnames(
              'list-menu-mobile',
              {loaded: this.state.active},
            )}
          >
            {listMenu}
          </div>
        </div>
      </React.Fragment>
    );
  }

}

MenuMobile.propTypes = propTypes;
MenuMobile.defaultProps = defaultProps;

export default withRouter(MenuMobile);



// WEBPACK FOOTER //
// ./src/molecules/MenuMobile/MenuMobile.js